import type { Question } from './question'
import type { QuizAnswer } from './result'

// Pure scoring logic — deliberately kept out of any page/component so it
// can be unit-tested and reused unchanged if a future phase moves scoring
// server-side (P5). Works uniformly across all four question types because
// correctness is always "the selected option-id set exactly equals the
// correct option-id set" (multiple_choice/true_false/scenario have one
// correct id; multi_select can have several).
export function isAnswerCorrect(question: Question, selectedOptionIds: string[]): boolean {
  const correct = new Set(question.correctOptionIds)
  const selected = new Set(selectedOptionIds)
  if (correct.size !== selected.size) return false
  for (const id of correct) {
    if (!selected.has(id)) return false
  }
  return true
}

export interface ScoredQuiz {
  answers: QuizAnswer[]
  correctCount: number
  total: number
  scorePercent: number
}

export function scoreQuiz(questions: Question[], selections: Record<string, string[]>): ScoredQuiz {
  const answers: QuizAnswer[] = questions.map((q) => {
    const selectedOptionIds = selections[q.id] ?? []
    return { questionId: q.id, selectedOptionIds, isCorrect: isAnswerCorrect(q, selectedOptionIds) }
  })
  const correctCount = answers.filter((a) => a.isCorrect).length
  const total = questions.length
  const scorePercent = total === 0 ? 0 : Math.round((correctCount / total) * 100)
  return { answers, correctCount, total, scorePercent }
}
